// import { useState } from "react";
// import { useLocation } from "react-router-dom";
// import { Box, Grid } from "@mui/material";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";

// import OrdersOverview from "../dashboard/orders-overview/OrdersOverview";

// import { useOrdersData } from "./OrdersDataFetcher";
// import OrdersFilters from "./OrdersFilters";
// import OrdersActionsBar from "./OrdersActionsBar";
// import OrdersDataGrid from "./OrdersDataGrid";
// import OrdersModalManager from "./OrdersModalManager";

// export default function OrdersTable({
//   isLatestOrders = false,
//   type,
//   onGetLatestOrders,
//   shouldRefreshData = false,
// }) {
//   const [open, setOpen] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [showReleaseOrdersDialog, setShowReleaseOrdersDialog] = useState(false);
//   const [showAssignPickerDialog, setShowAssignPickerDialog] = useState(false);
//   const [showMarkAsCompletedDialog, setShowMarkAsCompletedDialog] =
//     useState(false);

//   const location = useLocation();

//   const {
//     activeStatus,
//     orderStatus,
//     pickers,
//     filterData,
//     submittedData,
//     selectedJobIds,
//     loading,
//     isSubmitting,
//     isSubmittingMarkAsCompleted,
//     refreshOverviewTrigger,
//     paginationModel,
//     rowCount,
//     sortModel,
//     gridRows,
//     hasReason,
//     shouldHideStatus,
//     isDelayPicking,
//     isFakeCustomerOrder,
//     tooltipMessage,
//     isCheckBoxSelection,

//     // State setters
//     setActiveStatus,
//     setSelectedJobIds,
//     setPaginationModel,

//     // Functions
//     fetchOrders,
//     handleRowClick,
//     handleChangeFilter,
//     onFilterClick,
//     handleRemove,
//     handleClearFilters,
//     handleSortModelChange,
//     handleOpenReleaseOrdersDialog: canOpenReleaseDialog,
//     handleConfirmReleaseOrders,
//     handleOpenAssignPickerDialog: canOpenAssignDialog,
//     handleOpenMarkAsCompletedDialog: canOpenMarkAsCompletedDialog,
//     handleMarkAsCompleted,
//     triggerOverviewRefresh,
//     handleStatusLabelClick,
//   } = useOrdersData({
//     isLatestOrders,
//     type,
//     onGetLatestOrders,
//     shouldRefreshData,
//   });

//   const handleClose = () => {
//     setOpen(false);
//     fetchOrders();
//   };

//   const handleOpenReleaseOrdersDialog = () => {
//     if (canOpenReleaseDialog()) {
//       setShowReleaseOrdersDialog(true);
//     }
//   };

//   const handleOpenAssignPickerDialog = () => {
//     if (canOpenAssignDialog()) {
//       setShowAssignPickerDialog(true);
//     }
//   };

//   const handleOpenMarkAsCompletedDialog = () => {
//     if (canOpenMarkAsCompletedDialog()) {
//       setShowMarkAsCompletedDialog(true);
//     }
//   };

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       {location.pathname !== "/" && (
//         <Grid container spacing={3} sx={{ mb: 5 }}>
//           <OrdersOverview
//             showRightStats={false}
//             hangingStyle={true}
//             refreshTrigger={refreshOverviewTrigger}
//             onStatusLabelClick={handleStatusLabelClick}
//           />
//         </Grid>
//       )}

//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "24px 16px",
//           paddingTop: isLatestOrders ? 0 : "24px",
//           borderRadius: "8px",
//         }}
//       >
//         <OrdersFilters
//           isLatestOrders={isLatestOrders}
//           activeStatus={activeStatus}
//           setActiveStatus={setActiveStatus}
//           filterOpen={filterOpen}
//           setFilterOpen={setFilterOpen}
//           filterData={filterData}
//           handleChangeFilter={handleChangeFilter}
//           onFilterClick={onFilterClick}
//           handleClearFilters={handleClearFilters}
//           handleRemove={handleRemove}
//           submittedData={submittedData}
//           orderStatus={orderStatus}
//           type={type}
//           triggerOverviewRefresh={triggerOverviewRefresh}
//           FilterBtn={FilterBtn}
//           FilterBtnUp={FilterBtnUp}
//         />
//         <OrdersActionsBar
//           type={type}
//           isCheckBoxSelection={isCheckBoxSelection}
//           selectedJobIds={selectedJobIds}
//           tooltipMessage={tooltipMessage}
//           isSubmitting={isSubmitting}
//           isSubmittingMarkAsCompleted={isSubmittingMarkAsCompleted}
//           handleOpenAssignPickerDialog={handleOpenAssignPickerDialog}
//           handleOpenReleaseOrdersDialog={handleOpenReleaseOrdersDialog}
//           handleOpenMarkAsCompletedDialog={handleOpenMarkAsCompletedDialog}
//         />
//         <OrdersDataGrid
//           isLatestOrders={isLatestOrders}
//           gridRows={gridRows}
//           hasReason={hasReason}
//           shouldHideStatus={shouldHideStatus}
//           isDelayPicking={isDelayPicking}
//           isFakeCustomerOrder={isFakeCustomerOrder}
//           type={type}
//           selectedJobIds={selectedJobIds}
//           setSelectedJobIds={setSelectedJobIds}
//           handleRowClick={(params) => {
//             setSelectedOrder(handleRowClick(params));
//             setOpen(true);
//           }}
//           loading={loading}
//           isCheckBoxSelection={isCheckBoxSelection}
//           paginationModel={paginationModel}
//           rowCount={rowCount}
//           sortModel={sortModel}
//           handleSortModelChange={handleSortModelChange}
//           setPaginationModel={setPaginationModel}
//         />
//         <OrdersModalManager
//           open={open}
//           handleClose={handleClose}
//           selectedOrder={selectedOrder}
//           showReleaseOrdersDialog={showReleaseOrdersDialog}
//           setShowReleaseOrdersDialog={setShowReleaseOrdersDialog}
//           selectedJobIds={selectedJobIds}
//           type={type}
//           isSubmitting={isSubmitting}
//           handleConfirmReleaseOrders={handleConfirmReleaseOrders}
//           pickers={pickers}
//           showAssignPickerDialog={showAssignPickerDialog}
//           setShowAssignPickerDialog={setShowAssignPickerDialog}
//           fetchOrders={fetchOrders}
//           setSelectedJobIds={setSelectedJobIds}
//           showMarkAsCompletedDialog={showMarkAsCompletedDialog}
//           setShowMarkAsCompletedDialog={setShowMarkAsCompletedDialog}
//           isSubmittingMarkAsCompleted={isSubmittingMarkAsCompleted}
//           handleMarkAsCompleted={handleMarkAsCompleted}
//         />
//       </Box>
//     </Box>
//   );
// }

// *****************************************************************************************************

import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Grid } from "@mui/material";

import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";

import OrdersOverview from "../dashboard/orders-overview/OrdersOverview";

import { useOrdersData } from "./OrdersDataFetcher";
import OrdersFilters from "./OrdersFilters";
import OrdersActionsBar from "./OrdersActionsBar";
import OrdersDataGrid from "./OrdersDataGrid";
import OrdersModalManager from "./OrdersModalManager";

export default function OrdersTable({
  isLatestOrders = false,
  type,
  onGetLatestOrders,
  shouldRefreshData = false,
}) {
  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showReleaseOrdersDialog, setShowReleaseOrdersDialog] = useState(false);
  const [showAssignPickerDialog, setShowAssignPickerDialog] = useState(false);
  const [showMarkAsCompletedDialog, setShowMarkAsCompletedDialog] =
    useState(false);

  const location = useLocation();

  const {
    activeStatus,
    orderStatus,
    pickers,
    filterData,
    submittedData,
    selectedJobIds,
    loading,
    isSubmitting,
    isSubmittingMarkAsCompleted,
    refreshOverviewTrigger,
    paginationModel,
    rowCount,
    sortModel,
    gridRows,
    hasReason,
    shouldHideStatus,
    isDelayPicking,
    isFakeCustomerOrder,
    tooltipMessage,
    isCheckBoxSelection,

    // ✨ NEW: Permission flags
    allowAssignPicker,
    allowMarkAsComplete,
    allowReleaseOrderAndAssignOrder,
    allowReleaseOrders,

    // State setters
    setActiveStatus,
    setSelectedJobIds,
    setPaginationModel,

    // Functions
    fetchOrders,
    handleRowClick,
    handleChangeFilter,
    onFilterClick,
    handleRemove,
    handleClearFilters,
    handleSortModelChange,
    handleOpenReleaseOrdersDialog: canOpenReleaseDialog,
    handleConfirmReleaseOrders,
    handleOpenAssignPickerDialog: canOpenAssignDialog,
    handleOpenMarkAsCompletedDialog: canOpenMarkAsCompletedDialog,
    handleMarkAsCompleted,
    triggerOverviewRefresh,
    handleStatusLabelClick,
  } = useOrdersData({
    isLatestOrders,
    type,
    onGetLatestOrders,
    shouldRefreshData,
  });

  const handleClose = () => {
    setOpen(false);
    fetchOrders();
  };

  const handleOpenReleaseOrdersDialog = () => {
    if (canOpenReleaseDialog()) {
      setShowReleaseOrdersDialog(true);
    }
  };

  const handleOpenAssignPickerDialog = () => {
    if (canOpenAssignDialog()) {
      setShowAssignPickerDialog(true);
    }
  };

  const handleOpenMarkAsCompletedDialog = () => {
    if (canOpenMarkAsCompletedDialog()) {
      setShowMarkAsCompletedDialog(true);
    }
  };

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      {location.pathname !== "/" && (
        <Grid container spacing={3} sx={{ mb: 5 }}>
          <OrdersOverview
            showRightStats={false}
            hangingStyle={true}
            refreshTrigger={refreshOverviewTrigger}
            onStatusLabelClick={handleStatusLabelClick}
          />
        </Grid>
      )}

      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          paddingTop: isLatestOrders ? 0 : "24px",
          borderRadius: "8px",
        }}
      >
        <OrdersFilters
          isLatestOrders={isLatestOrders}
          activeStatus={activeStatus}
          setActiveStatus={setActiveStatus}
          filterOpen={filterOpen}
          setFilterOpen={setFilterOpen}
          filterData={filterData}
          handleChangeFilter={handleChangeFilter}
          onFilterClick={onFilterClick}
          handleClearFilters={handleClearFilters}
          handleRemove={handleRemove}
          submittedData={submittedData}
          orderStatus={orderStatus}
          type={type}
          triggerOverviewRefresh={triggerOverviewRefresh}
          FilterBtn={FilterBtn}
          FilterBtnUp={FilterBtnUp}
        />
        
        <OrdersActionsBar
          type={type}
          isCheckBoxSelection={isCheckBoxSelection}
          selectedJobIds={selectedJobIds}
          tooltipMessage={tooltipMessage}
          isSubmitting={isSubmitting}
          isSubmittingMarkAsCompleted={isSubmittingMarkAsCompleted}
          handleOpenAssignPickerDialog={handleOpenAssignPickerDialog}
          handleOpenReleaseOrdersDialog={handleOpenReleaseOrdersDialog}
          handleOpenMarkAsCompletedDialog={handleOpenMarkAsCompletedDialog}
          // ✨ NEW: Pass permission flags
          allowAssignPicker={allowAssignPicker}
          allowMarkAsComplete={allowMarkAsComplete}
          allowReleaseOrderAndAssignOrder={allowReleaseOrderAndAssignOrder}
          allowReleaseOrders={allowReleaseOrders}
        />
        
        <OrdersDataGrid
          isLatestOrders={isLatestOrders}
          gridRows={gridRows}
          hasReason={hasReason}
          shouldHideStatus={shouldHideStatus}
          isDelayPicking={isDelayPicking}
          isFakeCustomerOrder={isFakeCustomerOrder}
          type={type}
          selectedJobIds={selectedJobIds}
          setSelectedJobIds={setSelectedJobIds}
          handleRowClick={(params) => {
            setSelectedOrder(handleRowClick(params));
            setOpen(true);
          }}
          loading={loading}
          isCheckBoxSelection={isCheckBoxSelection}
          paginationModel={paginationModel}
          rowCount={rowCount}
          sortModel={sortModel}
          handleSortModelChange={handleSortModelChange}
          setPaginationModel={setPaginationModel}
        />
        
        <OrdersModalManager
          open={open}
          handleClose={handleClose}
          selectedOrder={selectedOrder}
          showReleaseOrdersDialog={showReleaseOrdersDialog}
          setShowReleaseOrdersDialog={setShowReleaseOrdersDialog}
          selectedJobIds={selectedJobIds}
          type={type}
          isSubmitting={isSubmitting}
          handleConfirmReleaseOrders={handleConfirmReleaseOrders}
          pickers={pickers}
          showAssignPickerDialog={showAssignPickerDialog}
          setShowAssignPickerDialog={setShowAssignPickerDialog}
          fetchOrders={fetchOrders}
          setSelectedJobIds={setSelectedJobIds}
          showMarkAsCompletedDialog={showMarkAsCompletedDialog}
          setShowMarkAsCompletedDialog={setShowMarkAsCompletedDialog}
          isSubmittingMarkAsCompleted={isSubmittingMarkAsCompleted}
          handleMarkAsCompleted={handleMarkAsCompleted}
        />
      </Box>
    </Box>
  );
}